import { Card, Form, Input, Button, message } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'

function ChangePassword() {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const [form] = Form.useForm()

  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }

  const handleSubmit = async (values) => {
    setSaving(true)
    try {
      await axios.put(
        '/api/auth/change-password',
        {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword
        },
        { headers }
      )
      message.success(t('changePassword.successMsg'))
      form.resetFields()
    } catch (err) {
      message.error(err.response?.data?.error || t('changePassword.errorMsg'))
    }
    setSaving(false)
  }

  return (
    <Card
      title={<span><LockOutlined /> {t('changePassword.title')}</span>}
      style={{ maxWidth: 480 }}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item
          name="currentPassword"
          label={t('changePassword.currentPasswordLabel')}
          rules={[{ required: true, message: t('changePassword.currentPasswordRequired') }]}
        >
          <Input.Password placeholder="••••••••" size="large" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label={t('changePassword.newPasswordLabel')}
          rules={[
            { required: true, message: t('changePassword.newPasswordRequired') },
            { min: 6, message: t('changePassword.newPasswordMin') }
          ]}
          hasFeedback
        >
          <Input.Password placeholder="••••••••" size="large" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={t('changePassword.confirmPasswordLabel')}
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            { required: true, message: t('changePassword.confirmPasswordRequired') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error(t('changePassword.passwordMismatch')))
              }
            })
          ]}
        >
          <Input.Password placeholder="••••••••" size="large" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          loading={saving}
        >
          {t('changePassword.submitBtn')}
        </Button>
      </Form>
    </Card>
  )
}

export default ChangePassword
